import { useMemo } from "react";

import createBrowserNetwork from "@framework/relay/browser/network/createBrowserNetwork";
import createEnvironment from "@framework/relay/shared/createEnvironment";
import { HydrationData } from "@framework/relay/shared/hydration";
import type { CommunityConfig } from "@voxmedia/duet-context/context/config-context";

const useRelayEnvironment = (
  hydration: HydrationData,
  token: string | undefined,
  communityConfig: CommunityConfig,
) => {
  const environment = useMemo(() => {
    const { communityId } = communityConfig;

    return createEnvironment(
      createBrowserNetwork({
        hydrationData: hydration,
        communityId,
        token: token,
      }),
    );
  }, [communityConfig, hydration, token]);

  return environment;
};

export default useRelayEnvironment;
